import { createSelector } from '@reduxjs/toolkit';
import { isNull } from 'lodash';

import { getToken } from './authStore';

export const getIsLogged = createSelector(
  getToken,
  jwt => !isNull(jwt),
);
